import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { PblNgridRegistryService, PblColumn } from '@pebula/ngrid';

@Component({
  selector: 'sg-common-ngrid-columns',
  templateUrl: './common-sg-table-columns.component.html',
  styleUrls: ['./common-sg-table-columns.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SgCommonSgTableColumnsComponent implements AfterViewInit {
  constructor(private tplRegistry: PblNgridRegistryService) {
    // blocking emission of change event from the registry so all table related templates we register
    // in this component's template will fire in a single emission.
    this.tplRegistry.bufferStart();
  }

  ngAfterViewInit(): void {
    this.tplRegistry.bufferEnd();
  }

  getNumberFormat(col: PblColumn): string {
    if (col && col.type && col.type.data) {
      if (col.type.data.format) {
        return col.type.data.format;
      }
    }
    return '1.0-2';
  }

  getCurrencyCode(col: PblColumn, row: any): string {
    if (col && col.type && col.type.data && col.type.data.currencyCode) {
      if (typeof col.type.data.currencyCode === 'function') {
        return col.type.data.currencyCode(row);
      } else {
        return col.type.data.currencyCode;
      }
    }
    return 'USD';
  }
}
